import React from "react";
import {
  STRETCHER_WIDTH_OPTIONS,
  STRETCHER_LENGTH_OPTIONS,
  STRETCHER_STYLE_OPTIONS,
  STRETCHER_THICKNESS_OPTIONS,
  STRETCHER_CORNER_OPTIONS,
} from "../constant";
import styles from "./ORStretcherPads.module.scss";
import { SubmissionSuccess } from "./SubmissionSuccess";
import { SelectField } from "../SelectField";
import { FormActions } from "../FormActions";
import { CustomOrderForm } from "./CustomOrderForm";

const FIELDS = [
  { key: "width", label: "Select Width", options: STRETCHER_WIDTH_OPTIONS, placeholder: "Select width" },
  { key: "length", label: "Select Length", options: STRETCHER_LENGTH_OPTIONS, placeholder: "Select length" },
  { key: "style", label: "Select Style", options: STRETCHER_STYLE_OPTIONS, placeholder: "Select style" },
  { key: "thickness", label: "Select Thickness", options: STRETCHER_THICKNESS_OPTIONS, placeholder: "Select thickness" },
  { key: "corner", label: "Corner Style (all 4 corners)", options: STRETCHER_CORNER_OPTIONS, placeholder: "Select corner style" },
];

export const StretcherPadView = ({ formData, setFormData, errors, submitting, submitted, onSubmit, onDownload }) => {
  return (
    <div className={styles.section}>
      <CustomOrderForm onDownload={onDownload} padType="stretcher" />

      {FIELDS.map((field) => (
        <SelectField
          key={field.key}
          id={`stretcher-${field.key}`}
          label={field.label}
          required
          value={formData[field.key]}
          onChange={(v) => setFormData((prev) => ({ ...prev, [field.key]: v }))}
          options={field.options}
          placeholder={field.placeholder}
          error={errors[field.key]}
        />
      ))}

      {submitted && (
        <SubmissionSuccess message="Your request for the stretcher pad has been submitted. A Medline respresentative will contact you shortly" />
      )}

      <FormActions onClick={onSubmit} loading={submitting} label="Submit" />
    </div>
  );
};
